import React from 'react';
import {observer} from "mobx-react";
import useFeature from "../../useFeature";
import saporeLogo from "../../media/logos/logo-sapore.png";
import {LogoutFeature} from "./LogoutFeature";
import {useApplication} from "../../ApplicationProvider";

function LogoutScreen() {
    const application = useApplication()
    useFeature(() => new LogoutFeature(application))

    return (
        <div className="bg-login relative">
            <div className="center-center width100">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <img src={saporeLogo} className="img-logo-login" alt="Logo Sapore Di Pane"/>
                                    <h3 className="text-center clearmargin">Cerrando sesión...</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default observer(LogoutScreen);
